module.exports = __webpack_public_path__ + "static/media/icon-pin.92736b5c.svg";